import { defineStore } from 'pinia'
import instance from '@/axios' 

interface UserData {
  id: number
  name: string
  mail: string,
  invoiceAddress:string,
  invoiceMail:string,
  invoiceMobile:string
}

interface AuthState {
  isLoggedIn: boolean
  userRole: string
  userData: UserData | null
  token: string | null
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    isLoggedIn: false,
    userRole: '',
    userData: null,
    token: localStorage.getItem('token') || null,
  }),
  actions: {
    async login(userCredentials: { mail: string; password: string }) {
      try {
        const response = await instance.post('/login', userCredentials)
        const { token, role, userData } = response.data.Result
        localStorage.setItem('token', token)
        this.token = token
        this.isLoggedIn = true
        this.userRole = role
        this.userData = userData
      } catch (error) {
        alert(error)
      }
    },
    logout() {
      localStorage.removeItem('token')
      this.token = null
      this.isLoggedIn = false
      this.userRole = ''
      this.userData = null
    },
  },
  
  getters: {
    getUserData: (state) => state.userData,
    getRole: (state) => state.userRole,
    getToken: (state) => state.token,
    isAuthenticated: (state) => state.isLoggedIn,
  },
  persist:true
})
